import { SmartEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartEdge/SmartEdge';
import { svgDrawStraightLinePath } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/functions/drawSvgPath.ts';
import { pathfindingJumpPointNoDiagonal } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/functions/generatePath.ts';
import { Edge, EdgeProps, Node, StepEdge, useNodes } from '@xyflow/react';
import { SmartEdgeOptions } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartEdge/SmartEdge.types';

const StepConfiguration: SmartEdgeOptions = {
	drawEdge: svgDrawStraightLinePath,
	generatePath: pathfindingJumpPointNoDiagonal,
	fallback: StepEdge,
	gridRatio: 6,
	gridRatioDragging: 6,
	nodeXPadding: 20,
	nodeYPadding: 20,
	withConnectorPadding: true,
};

export function SmartStepEdge<EdgeDataType extends Edge = Edge, NodeDataType extends Node = Node>(
	props: EdgeProps<EdgeDataType>
) {
	const nodes = useNodes<Node<NodeDataType>>();

	return (
		<SmartEdge<EdgeDataType, NodeDataType>
			{...props}
			options={StepConfiguration}
			labelStyle={props.label ? props.labelStyle : { display: 'none' }}
			nodes={nodes}
		/>
	);
}
